import { ISectionHeaderProps } from "./SectionHeader";

export const View = ({ title, subtitle }: ISectionHeaderProps) => {
  return (
    <div className="section-header--container">
      <h3 className="font-ctm--bold">{title}</h3>
      <p>
        <span>{subtitle}</span>
      </p>
    </div>
  );
};
